import { ThreeDSecureInfo } from 'braintree-web/three-d-secure';

export class LiabilityNotShiftedError extends Error {
  public readonly failureStatus: string | undefined;

  constructor(payload: ThreeDSecureInfo) {
    super(`Liability not shifted! status = "${payload.status}"`);
    this.name = 'LiabilityNotShiftedError';
    this.failureStatus = payload.status;
  }
}
